<div [style.position]="'relative'" [style.cursor]="showingSIN ? 'pointer' : 'not-allowed'">
  <input
    [hidden]="showMaskedSIN"
    class="sin-input"
    type="text"
    inputmode="text"
    autocomplete="off"
    [attr.id]="controlId"
    [maskito]="maskOptions"
    [value]="value"
    [disabled]="disabled"
    [placeholder]="placeholder"
    [ngClass]="{
      'error-border': error
    }"
    (input)="handleInput($event)"
    (blur)="handleBlur()" />

  <div
    #hiddenSIN
    [hidden]="!showMaskedSIN"
    class="sin-input sin-input-hidden"
    [attr.contenteditable]="false"
    [ngClass]="{
      'error-border': error,
      disabled: disabled
    }"></div>
  <button
    class="eye"
    (click)="toggleShowHide()"
    [disabled]="disabled"
    type="button"
    [ngClass]="{
      opened: !showMaskedSIN,
      closed: showMaskedSIN,
      error: error,
      disabled: disabled
    }"></button>
</div>
